
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PoweredBy',

  data() {
    return {
      maqqieLogo: require('@/assets/images/maqqie-logo.svg'),
    };
  },
});
